import React from 'react'

export default function DeliveryGuide() {
  return (
    <div>DeliveryGuide</div>
  )
}
